import React, { useState, useEffect } from 'react';
import api from '../api';
import toast from 'react-hot-toast';
import { format } from 'date-fns';

export default function Announcements() {
  const [title, setTitle] = useState('');
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);
  const [history, setHistory] = useState([]);

  const fetchHistory = async () => {
    try {
      const { data } = await api.get('/notifications');
      setHistory(data.filter(n => n.type === 'announcement'));
    } catch (e) {
      // ignore
    }
  };

  useEffect(() => { fetchHistory(); }, []);

  const sendAnnouncement = async (e) => {
    e.preventDefault();
    if (!title.trim()) return toast.error('Title is required');
    setSending(true);
    try {
      const { data } = await api.post('/notifications/announce', { title, message });
      toast.success(data.message);
      setTitle('');
      setMessage('');
      fetchHistory();
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to send');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="fadein">
      <div className="page-header">
        <div>
          <div className="page-title">Announcements</div>
          <div className="page-subtitle">Send notifications to all employees</div>
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20, alignItems: 'start' }}>
        {/* Send form */}
        <div className="card" style={{ padding: 20 }}>
          <div style={{ fontWeight: 600, fontSize: 13.5, color: 'var(--text-1)', marginBottom: 16 }}>New Announcement</div>
          <form onSubmit={sendAnnouncement}>
            <div className="form-group">
              <label>Title</label>
              <input
                value={title}
                onChange={e => setTitle(e.target.value)}
                placeholder="Announcement title"
                required
              />
            </div>
            <div className="form-group">
              <label>Message</label>
              <textarea
                rows={4}
                value={message}
                onChange={e => setMessage(e.target.value)}
                placeholder="Write your announcement..."
                style={{ resize: 'vertical' }}
              />
            </div>
            <button className="btn btn-primary" type="submit" disabled={sending} style={{ width: '100%' }}>
              {sending ? 'Sending...' : 'Send to All Employees'}
            </button>
          </form>
        </div>

        {/* History */}
        <div className="card" style={{ padding: 20 }}>
          <div style={{ fontWeight: 600, fontSize: 13.5, color: 'var(--text-1)', marginBottom: 16 }}>Recent Announcements</div>
          {history.length === 0 ? (
            <div className="empty" style={{ padding: '24px 0' }}>
              <div className="empty-icon"></div>
              <p>No announcements yet</p>
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              {history.slice(0, 20).map(n => (
                <div key={n._id} style={{ padding: '12px 14px', background: 'var(--surface-2)', borderRadius: 'var(--r)', border: '1px solid var(--border-light)' }}>
                  <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 4, color: 'var(--text-1)' }}>{n.title}</div>
                  {n.message && (
                    <div style={{ fontSize: 12.5, color: 'var(--text-2)', marginBottom: 6 }}>{n.message}</div>
                  )}
                  <div style={{ fontSize: 11, color: 'var(--text-3)' }}>
                    {n.createdAt ? format(new Date(n.createdAt), 'MMM d, yyyy h:mm a') : ''}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
